import React, { useState, useEffect } from "react";
import { Col, Row, Image, Dropdown, DropdownButton } from "react-bootstrap";
import { WizardSteps } from "./WizardSteps";
import { Nextsteps } from "./NextStep";
import warning from "../../assets/icons/warning.png";

import "react-datepicker/dist/react-datepicker.css";
export const Fifth = (props) => {
  const validate = () => {
    if (window.confirm("Are you sure you want to go back?")) {
      // eslint-disable-line
      props.previousStep();
    }
  };

  const [state, updateState] = useState({
    employment: [
      {
        employerName: "",
        jobTitle: "",
        startMonth: "",
        startYear: "",
        endMonth: "",
        endYear: "",
        isCurrentJob: false,
      },
    ],
    education: [
      {
        schoolName: "",
        degree: "",
        grade: "",
        startMonth: "",
        startYear: "",
        endMonth: "",
        endYear: "",
        isCurrent: false,
      },
    ],
  });
  const educationAdd = () => {
    state.education.push({
      schoolName: "",
      degree: "",
      grade: "",
      startMonth: "",
      startYear: "",
      endMonth: "",
      endYear: "",
      isCurrent: false,
    });
    updateState({
      ...state,
      education,
    });
  };
  const positionAdd = () => {
    state.employment.push({
      employerName: "",
      jobTitle: "",
      startMonth: "",
      startYear: "",
      endMonth: "",
      endYear: "",
      isCurrentJob: false,
    });
    updateState({
      ...state,
      employment,
    });
  };

  const onCurrentWork = (index, rollStatus) => {
    const { employment, education } = state;
    return (
      rollStatus === "isCurrentJob"
        ? (employment[index][rollStatus] = !employment[index][rollStatus])
        : (education[index][rollStatus] = !education[index][rollStatus]),
      updateState({
        employment,
        education,
        ...state,
      })
    );
  };

  const onTextChange = (e, index) => {
    const { employment, education } = state;
    return (
      e.target.name === "employerName" || e.target.name === "jobTitle"
        ? (employment[index][e.target.name] = e.target.value)
        : (education[index][e.target.name] = e.target.value),
      updateState({
        employment,
        education,
        ...state,
      })
    );
  };

  useEffect(() => {
    let { employment, education } = state;
    let TutorInfoObj = props?.TutorInfoObj ? props?.TutorInfoObj : {};
    employment = TutorInfoObj?.step5?.employment;
    education = TutorInfoObj?.step5?.education;
    if (employment && education)
      updateState((state) => ({
        ...state,
        employment,
        education,
      }));
    if (props.funcStatus === "loading..." && props.currentStep === 5) {
      submitStep5Info(true);
    }
  }, [props]);

  // step5: {
  //   employment: [
  //     {
  //       employerName: "London Eye",
  //       jobTitle: "Tour guide",
  //       startDate: "2020-04-27T20:12:55.53",
  //       endDate: "2020-04-27T20:12:55.53",
  //       isCurrentJob: false,
  //     },
  //   ],
  //   education: [
  //     {
  //       schoolName: "University of Lancaster",
  //       degree: "BSc.",
  //       startDate: "2010-04-27T20:12:55.53",
  //       endDate: "2014-04-27T20:12:55.53",
  //       isCurrent: false,
  //     },
  //     {
  //       schoolName: "University of Liverppol",
  //       degree: "Masters",
  //       startDate: "2020-04-27T20:12:55.53",
  //       endDate: "",
  //       isCurrent: true,
  //     },
  //   ],
  // },

  const submitStep5Info = (isCallApi) => {
    const { employment, education } = state;
    const { TutorInfoObj } = props;

    let step5 = {
      employment,
      education,
    };
    TutorInfoObj.step5 = step5;
    props.AddTutorInfo(TutorInfoObj);
    return isCallApi ? props.AddTutorInfoStepBeforeCallApi("done") : null;
    // if (
    //   employment.length &&
    //   education.length &&
    //   education[0].schoolName &&
    //   education[0].degree &&
    //   education[0].startDate &&
    //   (education[0].endDate || education[0].isCurrent) &&
    //   employment[0].employerName &&
    //   employment[0].jobTitle &&
    //   employment[0].startDate &&
    //   (employment[0].endDate || employment[0].isCurrentJob)
    // ) {
    //   TutorInfoObj.step5 = step5;
    //   props.AddTutorInfo(TutorInfoObj);
    //   return true;
    // } else {
    //   return false;
    // }
  };

  const year = new Date().getFullYear();
  const months = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  let years = [];

  for (let x = year; x >= 1960; x--) {
    years.push(x);
  }

  const { employment, education } = state;
  const { iscompletedForm, validationError } = props;

  let warningError = (
    <img
      src={warning}
      alt="warning"
      width="14px"
      height="14px"
      style={{ marginRight: "6px" }}
    />
  );

  return (
    <Row className="m-0">
      <WizardSteps step={5} {...props} previousStep={validate} />
      <Col lg={12} md={12} sm={12} xs={12}>
        <div className="container">
          <Row>
            <Col lg={12} md={12} sm={12} xs={12} className="subject-mode work">
              {education?.length
                ? education.map((value, index) => {
                    return (
                      <div key={index}>
                        <p className="step-title">
                          Add details about your education
                        </p>
                        <p className="label-input">
                          School/University/Other institution
                        </p>
                        <input
                          type="text"
                          name="schoolName"
                          value={value.schoolName}
                          onChange={(e) => onTextChange(e, index)}
                          disabled={!iscompletedForm ? false : true}
                          placeholder="School/University/Other institution"
                          className={
                            !value.schoolName
                              ? validationError?.data
                                ? "form-control errorInput"
                                : "form-control"
                              : "form-control"
                          }
                        />
                        <div className="error">
                          {!value.schoolName
                            ? validationError?.data
                              ? warningError
                              : ""
                            : ""}
                          {!value.schoolName
                            ? validationError?.data
                              ? "Add at least one education"
                              : ""
                            : ""}
                        </div>

                        <p className="label-input ">Qualification </p>
                        <input
                          type="text"
                          name="degree"
                          value={value.degree}
                          className="form-control"
                          placeholder="Qualifilcation"
                          onChange={(e) => onTextChange(e, index)}
                          disabled={!iscompletedForm ? false : true}
                          className={
                            !value.degree
                              ? validationError?.data
                                ? "form-control errorInput"
                                : "form-control"
                              : "form-control"
                          }
                        />
                        <div className="error">
                          {!value.degree
                            ? validationError?.data
                              ? warningError
                              : ""
                            : ""}
                          {!value.degree
                            ? validationError?.data
                              ? "Add course title or qualification"
                              : ""
                            : ""}
                        </div>

                        <div
                          className="checkBoxContainer"
                          style={{ marginTop: "17px" }}
                        >
                          <label
                            className="container"
                            htmlFor={`customCheck${index}`}
                          >
                            <span className="currently">
                              I am currently enrolled at this institution
                            </span>
                            <input
                              type="checkbox"
                              id={`customCheck${index}`}
                              defaultChecked={value.isCurrent}
                              onClick={
                                !iscompletedForm
                                  ? () => onCurrentWork(index, "isCurrent")
                                  : () => {}
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>

                        {!value.isCurrent ? (
                          <div>
                            <p className="label-input ">
                              Degree classification or grade{" "}
                            </p>
                            <input
                              type="text"
                              name="grade"
                              value={value.grade}
                              className="form-control"
                              onChange={(e) => onTextChange(e, index)}
                              disabled={!iscompletedForm ? false : true}
                              placeholder="Degree classification or grade"
                              className={
                                !value.grade
                                  ? validationError?.data
                                    ? "form-control errorInput"
                                    : "form-control"
                                  : "form-control"
                              }
                            />
                            <div className="error">
                              {!value.grade
                                ? validationError?.data
                                  ? warningError
                                  : ""
                                : ""}
                              {!value.grade
                                ? validationError?.data
                                  ? "Add degree classification, final results or grade"
                                  : ""
                                : ""}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}

                        <Row className="date">
                          <Col lg={6} md={6} sm={12} xs={12}>
                            <Row className="m-0">
                              <p
                                className="label-input"
                                style={{ display: "flex", fontSize: "16px" }}
                              >
                                Start date
                              </p>
                            </Row>
                            <Row>
                              <Col>
                                <DropdownButton
                                  id="dropdown-basic-button"
                                  title={
                                    <span
                                      className={
                                        !value.startMonth
                                          ? validationError?.data
                                            ? "errorInput"
                                            : ""
                                          : ""
                                      }
                                    >
                                      {value.startMonth
                                        ? value.startMonth
                                        : "Month"}
                                      <Image
                                        style={{ width: "15px" }}
                                        src={require("./../../assets/icons/down-arrow.png")}
                                      />
                                    </span>
                                  }
                                >
                                  {months.map((month, i) => {
                                    return (
                                      <Dropdown.Item
                                        key={index}
                                        className="dropdown-items"
                                        onClick={() => {
                                          education[index].startMonth = month;
                                          updateState({
                                            ...state,
                                            education: education,
                                          });
                                        }}
                                      >
                                        {month}
                                      </Dropdown.Item>
                                    );
                                  })}
                                </DropdownButton>
                                <div className="error">
                                  {!value.startMonth
                                    ? validationError?.data
                                      ? warningError
                                      : ""
                                    : ""}
                                  {!value.startMonth
                                    ? validationError?.data
                                      ? "Select start month"
                                      : ""
                                    : ""}
                                </div>
                              </Col>
                              <Col>
                                <DropdownButton
                                  id="dropdown-basic-button"
                                  title={
                                    <span
                                      className={
                                        !value.startYear
                                          ? validationError?.data
                                            ? "errorInput"
                                            : ""
                                          : ""
                                      }
                                    >
                                      {value.startYear
                                        ? value.startYear
                                        : "Year"}
                                      <Image
                                        style={{ width: "15px" }}
                                        src={require("./../../assets/icons/down-arrow.png")}
                                      />
                                    </span>
                                  }
                                >
                                  {years.map((year, i) => {
                                    return (
                                      <Dropdown.Item
                                        key={i}
                                        className="dropdown-items"
                                        onClick={() => {
                                          education[index].startYear = year;
                                          updateState({
                                            ...state,
                                            education: education,
                                          });
                                        }}
                                      >
                                        {year}
                                      </Dropdown.Item>
                                    );
                                  })}
                                </DropdownButton>
                                <div className="error">
                                  {!value.startYear
                                    ? validationError?.data
                                      ? warningError
                                      : ""
                                    : ""}
                                  {!value.startYear
                                    ? validationError?.data
                                      ? "Select start year"
                                      : ""
                                    : ""}
                                </div>
                              </Col>
                            </Row>
                          </Col>
                          {!value.isCurrent ? (
                            <Col lg={6} md={6} sm={12} xs={12}>
                              <Row className="m-0">
                                <p
                                  className="label-input"
                                  style={{ display: "flex", fontSize: "16px" }}
                                >
                                  End date
                                </p>
                              </Row>
                              <Row>
                                <Col>
                                  <DropdownButton
                                    id="dropdown-basic-button"
                                    title={
                                      <span
                                        className={
                                          !value.endMonth
                                            ? validationError?.data
                                              ? "errorInput"
                                              : ""
                                            : ""
                                        }
                                      >
                                        {value.endMonth
                                          ? value.endMonth
                                          : "Month"}
                                        <Image
                                          style={{ width: "15px" }}
                                          src={require("./../../assets/icons/down-arrow.png")}
                                        />
                                      </span>
                                    }
                                  >
                                    {months.map((month, i) => {
                                      return (
                                        <Dropdown.Item
                                          key={index}
                                          className="dropdown-items"
                                          onClick={() => {
                                            education[index].endMonth = month;
                                            updateState({
                                              ...state,
                                              education: education,
                                            });
                                          }}
                                        >
                                          {month}
                                        </Dropdown.Item>
                                      );
                                    })}
                                  </DropdownButton>
                                  <div className="error">
                                    {!value.endMonth
                                      ? validationError?.data
                                        ? warningError
                                        : ""
                                      : ""}
                                    {!value.endMonth
                                      ? validationError?.data
                                        ? "Select end month"
                                        : ""
                                      : ""}
                                  </div>
                                </Col>
                                <Col>
                                  <DropdownButton
                                    id="dropdown-basic-button"
                                    title={
                                      <span
                                        className={
                                          !value.endYear
                                            ? validationError?.data
                                              ? "errorInput"
                                              : ""
                                            : ""
                                        }
                                      >
                                        {value.endYear ? value.endYear : "Year"}
                                        <Image
                                          style={{ width: "15px" }}
                                          src={require("./../../assets/icons/down-arrow.png")}
                                        />
                                      </span>
                                    }
                                  >
                                    {years.map((year, i) => {
                                      return (
                                        <Dropdown.Item
                                          key={i}
                                          className="dropdown-items"
                                          onClick={() => {
                                            education[index].endYear = year;
                                            updateState({
                                              ...state,
                                              education: education,
                                            });
                                          }}
                                        >
                                          {year}
                                        </Dropdown.Item>
                                      );
                                    })}
                                  </DropdownButton>
                                  <div className="error">
                                    {!value.endYear
                                      ? validationError?.data
                                        ? warningError
                                        : ""
                                      : ""}
                                    {!value.endYear
                                      ? validationError?.data
                                        ? "Select end year"
                                        : ""
                                      : ""}
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          ) : (
                            ""
                          )}
                        </Row>
                      </div>
                    );
                  })
                : ""}

              <span
                onClick={!iscompletedForm ? educationAdd : () => {}}
                style={{ cursor: "pointer" }}
              >
                <i className="mdi mdi-plus mr-1 theme"></i>
                <span className="green-link-2" style={{ marginBottom: "44px" }}>
                  Add new education
                </span>
              </span>

              {employment?.length
                ? employment.map((value, index) => {
                    return (
                      <div key={index}>
                        <p className="step-title">Your work experience</p>

                        <p className="label-input">Company/Organisation name</p>
                        <input
                          type="text"
                          name="employerName"
                          className="form-control"
                          value={value.employerName}
                          placeholder="Employer name"
                          onChange={(e) => onTextChange(e, index)}
                          disabled={!iscompletedForm ? false : true}
                          className={
                            !value.employerName
                              ? validationError?.data
                                ? "form-control errorInput"
                                : "form-control"
                              : "form-control"
                          }
                        />
                        <div className="error">
                          {!value.employerName
                            ? validationError?.data
                              ? warningError
                              : ""
                            : ""}
                          {!value.employerName
                            ? validationError?.data
                              ? "Add Employer name"
                              : ""
                            : ""}
                        </div>

                        <p className="label-input ">Your role</p>
                        <input
                          type="text"
                          name="jobTitle"
                          value={value.jobTitle}
                          placeholder="Job title"
                          className="form-control"
                          onChange={(e) => onTextChange(e, index)}
                          disabled={!iscompletedForm ? false : true}
                          className={
                            !value.jobTitle
                              ? validationError?.data
                                ? "form-control errorInput"
                                : "form-control"
                              : "form-control"
                          }
                        />
                        <div className="error">
                          {!value.jobTitle
                            ? validationError?.data
                              ? warningError
                              : ""
                            : ""}
                          {!value.jobTitle
                            ? validationError?.data
                              ? "Add job title"
                              : ""
                            : ""}
                        </div>

                        <div
                          className="checkBoxContainer"
                          style={{ marginTop: "17px" }}
                        >
                          <label
                            className="container"
                            htmlFor={`customCheck2${index}`}
                          >
                            <span className="currently">
                              I am currently working in this role
                            </span>
                            <input
                              type="checkbox"
                              id={`customCheck2${index}`}
                              defaultChecked={value.isCurrentJob}
                              onClick={
                                !iscompletedForm
                                  ? () => onCurrentWork(index, "isCurrentJob")
                                  : () => {}
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>

                        <Row className="date">
                          <Col lg={6} md={6} sm={12} xs={12}>
                            <Row className="m-0">
                              <p
                                className="label-input"
                                style={{ display: "flex", fontSize: "16px" }}
                              >
                                Start date
                              </p>
                            </Row>
                            <Row>
                              <Col>
                                <DropdownButton
                                  id="dropdown-basic-button"
                                  title={
                                    <span
                                      className={
                                        !value.startMonth
                                          ? validationError?.data
                                            ? "errorInput"
                                            : ""
                                          : ""
                                      }
                                    >
                                      {value.startMonth
                                        ? value.startMonth
                                        : "Month"}
                                      <Image
                                        style={{ width: "15px" }}
                                        src={require("./../../assets/icons/down-arrow.png")}
                                      />
                                    </span>
                                  }
                                >
                                  {months.map((month, i) => {
                                    return (
                                      <Dropdown.Item
                                        key={i}
                                        className="dropdown-items"
                                        onClick={() => {
                                          employment[index].startMonth = month;
                                          updateState({
                                            ...state,
                                            employment: employment,
                                          });
                                        }}
                                      >
                                        {month}
                                      </Dropdown.Item>
                                    );
                                  })}
                                </DropdownButton>
                                <div className="error">
                                  {!value.startMonth
                                    ? validationError?.data
                                      ? warningError
                                      : ""
                                    : ""}
                                  {!value.startMonth
                                    ? validationError?.data
                                      ? "Select start month"
                                      : ""
                                    : ""}
                                </div>
                              </Col>
                              <Col>
                                <DropdownButton
                                  id="dropdown-basic-button"
                                  title={
                                    <span
                                      className={
                                        !value.startYear
                                          ? validationError?.data
                                            ? "errorInput"
                                            : ""
                                          : ""
                                      }
                                    >
                                      {value.startYear
                                        ? value.startYear
                                        : "Year"}
                                      <Image
                                        style={{ width: "15px" }}
                                        src={require("./../../assets/icons/down-arrow.png")}
                                      />
                                    </span>
                                  }
                                >
                                  {years.map((year, i) => {
                                    return (
                                      <Dropdown.Item
                                        key={i}
                                        className="dropdown-items"
                                        onClick={() => {
                                          employment[index].startYear = year;
                                          updateState({
                                            ...state,
                                            employment: employment,
                                          });
                                        }}
                                      >
                                        {year}
                                      </Dropdown.Item>
                                    );
                                  })}
                                </DropdownButton>
                                <div className="error">
                                  {!value.startYear
                                    ? validationError?.data
                                      ? warningError
                                      : ""
                                    : ""}
                                  {!value.startYear
                                    ? validationError?.data
                                      ? "Select start year"
                                      : ""
                                    : ""}
                                </div>
                              </Col>
                            </Row>
                          </Col>
                          {!value.isCurrentJob ? (
                            <Col lg={6} md={6} sm={12} xs={12}>
                              <Row className="m-0">
                                <p
                                  className="label-input"
                                  style={{ display: "flex", fontSize: "16px" }}
                                >
                                  End date
                                </p>
                              </Row>
                              <Row>
                                <Col>
                                  <DropdownButton
                                    id="dropdown-basic-button"
                                    title={
                                      <span
                                        className={
                                          !value.endMonth
                                            ? validationError?.data
                                              ? "errorInput"
                                              : ""
                                            : ""
                                        }
                                      >
                                        {value.endMonth
                                          ? value.endMonth
                                          : "Month"}
                                        <Image
                                          style={{ width: "15px" }}
                                          src={require("./../../assets/icons/down-arrow.png")}
                                        />
                                      </span>
                                    }
                                  >
                                    {months.map((month, i) => {
                                      return (
                                        <Dropdown.Item
                                          key={i}
                                          className="dropdown-items"
                                          onClick={() => {
                                            employment[index].endMonth = month;
                                            updateState({
                                              ...state,
                                              employment: employment,
                                            });
                                          }}
                                        >
                                          {month}
                                        </Dropdown.Item>
                                      );
                                    })}
                                  </DropdownButton>
                                  <div className="error">
                                    {!value.endMonth
                                      ? validationError?.data
                                        ? warningError
                                        : ""
                                      : ""}
                                    {!value.endMonth
                                      ? validationError?.data
                                        ? "Select end month"
                                        : ""
                                      : ""}
                                  </div>
                                </Col>
                                <Col>
                                  <DropdownButton
                                    id="dropdown-basic-button"
                                    title={
                                      <span
                                        className={
                                          !value.endYear
                                            ? validationError?.data
                                              ? "errorInput"
                                              : ""
                                            : ""
                                        }
                                      >
                                        {value.endYear ? value.endYear : "Year"}
                                        <Image
                                          style={{ width: "15px" }}
                                          src={require("./../../assets/icons/down-arrow.png")}
                                        />
                                      </span>
                                    }
                                  >
                                    {years.map((year, i) => {
                                      return (
                                        <Dropdown.Item
                                          key={i}
                                          className="dropdown-items"
                                          onClick={() => {
                                            employment[index].endYear = year;
                                            updateState({
                                              ...state,
                                              employment: employment,
                                            });
                                          }}
                                        >
                                          {year}
                                        </Dropdown.Item>
                                      );
                                    })}
                                  </DropdownButton>
                                  <div className="error">
                                    {!value.endYear
                                      ? validationError?.data
                                        ? warningError
                                        : ""
                                      : ""}
                                    {!value.endYear
                                      ? validationError?.data
                                        ? "Select end year"
                                        : ""
                                      : ""}
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          ) : (
                            ""
                          )}
                        </Row>
                      </div>
                    );
                  })
                : ""}

              <span
                onClick={!iscompletedForm ? positionAdd : () => {}}
                style={{ cursor: "pointer" }}
              >
                <i className="mdi mdi-plus mr-1 theme"></i>
                <span className="green-link-2">Add another position</span>
              </span>
            </Col>
          </Row>
          <Nextsteps step={5} {...props} submitStepInRedux={submitStep5Info} />
        </div>
      </Col>
    </Row>
  );
};
